import { GithubIcon, HamburgerClose, HamburgerOpen } from "./Icon";

import { useState } from "react";
import { Collapse } from "react-bootstrap";

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header>
      <div className="container">
        <div className="header-wrapper">
          <a href="#" className="logo">
            <img
              className="navbar-logo"
              src={process.env.PUBLIC_URL + "/img/carbonlogo.webp"}
              alt=""
            />
          </a>
          <div className="d-none d-md-block">
            <Menu />
          </div>
          <a
            href="https://github.com/CarbonCommunity/Carbon/releases/tag/production_build"
            target="_blank"
            rel="noreferrer"
            className="btn-base"
          >
            <span>Get Carbon</span>
            <GithubIcon />
          </a>
          <button
            className="d-md-none no-gutter hamburger-btn"
            onClick={() => setOpen(!open)}
          >
            {open ? <HamburgerClose /> : <HamburgerOpen />}
          </button>
          <Collapse in={open}>
            <div className="w-100 d-md-none">
              <div className="py-3">
                <Menu />
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </header>
  );
};

const Menu = () => {
  return (
    <>
      <ul className="menu ms-lg-auto">
        <li>
          <a href="#feature">Features</a>
        </li>
        <li>
          <a href="#discord">Discord</a>
        </li>
        <li>
          <a href="#documentation">Documentation</a>
        </li>
        <li>
          <a href="#plugins">Plugins</a>
        </li>
      </ul>
    </>
  );
};

export default Header;
